import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import { Divider } from '@mui/material';

const items = [
  {
    icon: <SettingsSuggestRoundedIcon />,
    title: 'Smart Access Control',
    description:
      'Automate vehicle entry and exit with license plate recognition, QR codes, or RFID for seamless and secure parking experiences.',
  },
  {
    icon: <ConstructionRoundedIcon />,
    title: 'Real-Time Monitoring',
    description:
      'Monitor all parking lot activity from a centralized dashboard with live camera feeds, occupancy data, and alert notifications.',
  },
  {
    icon: <ThumbUpAltRoundedIcon />,
    title: 'Flexible Payment Solutions',
    description:
      'Offer multiple payment options including mobile app, contactless cards, and online prepayment to improve convenience and reduce queues.',
  },
  {
    icon: <AutoFixHighRoundedIcon />,
    title: 'Mall Operations Integration',
    description:
      'Centralize the management of mall services—security, cleaning, maintenance, and leasing—under one powerful administration system.',
  },
  {
    icon: <QueryStatsRoundedIcon />,
    title: 'Custom Reports & Analytics',
    description:
      'Generate detailed reports on usage patterns, revenue, and customer behavior to optimize operations and boost profitability.',
  },
  {
    icon: <SupportAgentRoundedIcon /> ,
    title: 'Enhanced Customer Experience',
    description:
      'Improve visitor satisfaction with real-time space availability, digital receipts, loyalty programs, and mobile app support.',
  },
];

export default function Highlights() {
  return (
    <Container id = "app" maxWidth = {'xl'}  component='main'>
    <Divider sx={{my:8}}></Divider>
    <Stack spacing={2} >
      <Typography component="p"  variant="h3" color="black" sx={{fontWeight:'bolder'}} >
      Highlights
      </Typography>
      <Typography variant="body1" gutterBottom sx={{ color: 'grey.700' }}>

      We are a technology-driven company focused on revolutionizing the parking experience through smart, digital solutions. Our services integrate automation, security, and convenience to provide seamless parking access and management for individuals, businesses, and property administrators. With cutting-edge systems and user-centric platforms, we simplify urban mobility and facility operations.
      </Typography>
    </Stack> 
    <Grid container spacing={2.5} sx={{pt:8,pb:2}} >
    {items.map((item, index) => (
      <Grid item xs={12} sm={6} md={4} key={index}>
        <Stack
          direction="column"
          color="inherit"
          spacing={1}
          useFlexGap
          sx={{
            p: 3,
            height: '100%',
            borderRadius: 0,
            backgroundColor:"#fafafa"
          }}
        >
          <Box sx={{ opacity: '100%' }}>{item.icon}</Box>
          <div>
            <Typography variant="subtitle1" gutterBottom>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'grey.700' }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      </Grid>
    ))}
  </Grid>
</Container>
   

  );
}